// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewRecording__container-ab1c5f {
  display: flex;
  flex-direction: column;
}

.NewRecording__content-bc2b01 {
  padding: 24px;
  overflow: auto;
  color: var(--base-110);
}

.NewRecording__recording-type-e96812 {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/StartRecordingPopup/NewRecording/NewRecording.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  padding: 24px;\n  overflow: auto;\n  color: var(--base-110);\n}\n\n.recording-type {\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewRecording__container-ab1c5f`,
	"content": `NewRecording__content-bc2b01`,
	"recording-type": `NewRecording__recording-type-e96812`,
	"recordingType": `NewRecording__recording-type-e96812`
};
module.exports = ___CSS_LOADER_EXPORT___;
